import { Component, OnInit } from '@angular/core';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { EditorService } from '../services/editor.service';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { HomeInputComponent } from './home-input/home-input.component';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'kve-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
/**
 * Resolved through the Router
 * 1. Sets up the menu for editing the Home Page Route
 * 2. Sets up the Dynamic Input Component for editing the Home Page Route
 */
export class HomePageComponent implements OnInit {
  /**
   * Dynamic Input Component for editing the Home Page Route
   */
  inputComponent = new DynamicInputComponent(HomeInputComponent);
  menuGroups: any;
  title = "Editing Home Page Route";
  menuTag = "editHomePageRouteMenu";
  menuGroup: MenuGroup = {
    title: "Editing Home Page Route",
    menuTag: "editHomePageRouteMenu",
    menuItems: [
      {
        title: "Page Settings"
      },
      {
        title: "Sections"
      },
      {
        title: 'Add Section',
        children: [
          {
            title: 'Grid',
            /* children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ] */
          },
          {
            title: 'Banner'
          },
          {
            title: 'Hero Image'
          },
          {
            title: 'Slider'
          },
          {
            title: 'Slide Show'
          },
          {
            title: 'Blog List',
          },
          {
            title: 'Product List',
          },
          {
            title: 'Feature List',
          },
          {
            title: 'Testimonials'
          },
          {
            title: 'Rich Text'
          },
          {
            title: 'News Letter Sign Up'
          }
        ]
      },
      {
        title: 'Remove Section',
      },
      {
        title: 'Order Sections',
      },
    ]
  }
  previousMenu: NbMenuItem[] = [];
  menuItems: NbMenuItem[] = [
    {
      title: 'Add Section',
    },
    {
      title: 'Remove Section'
    },
    {
      title: 'Order Sections'
    }
  ]
  canSave$ = this.previewEditStoreService.canSavePage$;
  hasUnsavedChanges$ = this.previewEditStoreService.hasUnsavedChanges$;
  selectedPage$ = this.previewEditStoreService.selectedPage$;
  pageStatus: string = '';

  private destroy$ = new Subject<void>();

  constructor(
    private editorService: EditorService,
    private menuService: NbMenuService,
    private previewEditStoreService: PreviewEditStoreService
  ) { }

  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    // console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag => {
      console.log({ menuBag: menuBag });
      const selectedItem = menuBag.item;
      if (selectedItem != undefined) {
        // if(selectedItem.parent.title)
        this.setMenu(selectedItem);
        // console.log({selectedItem:selectedItem});
      }
    })
    this.previewEditStoreService.selectedPage$.subscribe(data => {
      console.log(data.pageId)
    })
    this.selectedPage$.subscribe(data => {
      const sections = data.sections;
      console.log(sections);
      this.pageStatus = data.status ? data.status : 'In Progress';
    })
    this.editorService.dialogClose$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log('Dialog closed with data:', data);
        this.menuItems = this.previousMenu;
        // Handle the close event
      });
  }
  /**
   * Sets the Menu Items based on the selected Menu Item
   * Sets to previous menu if "Back" is selected
   * Sets to children of selected menu item if it has children
   * @param selectedItem Selected Menu Item
   *
   */
  setMenu(selectedItem: NbMenuItem) {
    if (selectedItem.title == "Back") {
      this.menuItems = this.previousMenu;
    } else {
      this.menuGroup.menuItems.forEach(menuItem => {
        if (menuItem.title == selectedItem.title && menuItem.children != null) {
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          const backLinkLNbMenuItem = { title: "Back", icon: { icon: "arrow-back-outline", pack: "eva" } };
          const headerItem: NbMenuItem = { title: menuItem.title, group: true }
          this.menuItems = [backLinkLNbMenuItem, headerItem].concat(menuItem.children);
        }
      })
    }

  }



}
